import { cn } from '@/lib/cn'
import styles from './CaptionStyleCarousel.module.scss'

/** Espelha ``DEFAULT_ACTIVE_COLOR`` de ``subtitle_styles/karaoke.py``. */
export const DEFAULT_ACTIVE_COLOR = '#E8412C'

const SWATCHES: ReadonlyArray<{ color: string; label: string }> = [
  { color: DEFAULT_ACTIVE_COLOR, label: 'Vermelho' },
  { color: '#FFD400', label: 'Amarelo' },
  { color: '#FF8A00', label: 'Laranja' },
  { color: '#2CF07E', label: 'Verde' },
  { color: '#3DA5FF', label: 'Azul' },
  { color: '#C77DFF', label: 'Roxo' },
]

export interface CaptionColorPickerProps {
  /** ``#RRGGBB``; vazio = o vermelho padrão. */
  value: string
  onValueChange: (color: string) => void
}

/**
 * A cor da palavra sendo lida no estilo karaokê: amostras prontas e o seletor
 * nativo para qualquer outra. Escolher o vermelho padrão grava vazio, para o
 * preset seguir o default do backend em vez de congelar um hex.
 */
export function CaptionColorPicker({ value, onValueChange }: CaptionColorPickerProps) {
  const current = (value || DEFAULT_ACTIVE_COLOR).toUpperCase()
  const pick = (color: string) => {
    const upper = color.toUpperCase()
    onValueChange(upper === DEFAULT_ACTIVE_COLOR ? '' : upper)
  }
  return (
    <div className={styles.colorRow} role="group" aria-label="Cor da palavra sendo lida">
      <span className={styles.colorLabel}>Cor da palavra sendo lida</span>
      {SWATCHES.map((s) => (
        <button
          key={s.color}
          type="button"
          className={cn(styles.swatch, current === s.color && styles.swatchActive)}
          style={{ background: s.color }}
          onClick={() => {
            pick(s.color)
          }}
          aria-pressed={current === s.color}
          aria-label={s.label}
          title={s.label}
        />
      ))}
      <input
        type="color"
        className={styles.colorInput}
        value={current.toLowerCase()}
        onChange={(e) => {
          pick(e.target.value)
        }}
        aria-label="Outra cor"
        title="Outra cor"
      />
    </div>
  )
}
